import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-search-no-results',
  imports: [RmaIconComponent, TranslocoModule],
  providers: [provideTranslocoScope('dashboardSearch')],
  templateUrl: './search-no-results.component.html',
  styleUrls: ['./search-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchNoResultsComponent {}
